import { useAuth } from "@/hooks/useAuth";
import { useQuery } from "@tanstack/react-query";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminManagement } from "@/components/admin/AdminManagement";
import { ThemeManagement } from "@/components/admin/ThemeManagement";
import { SettingsManagement } from "@/components/admin/SettingsManagement";
import { CardTemplateManagement } from "@/components/admin/CardTemplateManagement";
import { HabitCategoryManagement } from "@/components/admin/HabitCategoryManagement";
import { ImportExportManagement } from "@/components/admin/ImportExportManagement";
import { PageHelpButton } from "@/components/PageHelpButton";
import { supabase } from "@/integrations/supabase/client";

export default function AdminSettings() {
  const { isSuperAdmin } = useAuth();

  const { data: cardTemplateEditorEnabled = true } = useQuery({
    queryKey: ["settings", "card_template_editor_enabled"],
    queryFn: async () => {
      const { data } = await supabase
        .from("settings")
        .select("value")
        .eq("key", "card_template_editor_enabled")
        .maybeSingle();
      if (!data) return true;
      return data.value === true || data.value === "true";
    },
    staleTime: 5 * 60 * 1000,
  });

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight" data-tour="settings-title">Paramètres</h1>
          <p className="mt-1 text-muted-foreground">Configuration de l'application</p>
        </div>
        <PageHelpButton tourKey="settings" />
      </div>

      <Tabs defaultValue="themes">
        <TabsList data-tour="settings-tabs">
          <TabsTrigger value="themes">Thèmes</TabsTrigger>
          {isSuperAdmin && <TabsTrigger value="habit-categories">Thématiques d'habitudes</TabsTrigger>}
          {isSuperAdmin && cardTemplateEditorEnabled && <TabsTrigger value="templates">Templates de cartes</TabsTrigger>}
          {isSuperAdmin && <TabsTrigger value="settings">Réglages</TabsTrigger>}
          {isSuperAdmin && <TabsTrigger value="admins">Gestion des admins</TabsTrigger>}
          {isSuperAdmin && <TabsTrigger value="import-export">Import / Export</TabsTrigger>}
        </TabsList>

        <TabsContent value="themes" className="mt-6">
          <ThemeManagement />
        </TabsContent>

        {isSuperAdmin && (
          <TabsContent value="habit-categories" className="mt-6">
            <HabitCategoryManagement />
          </TabsContent>
        )}

        {isSuperAdmin && cardTemplateEditorEnabled && (
          <TabsContent value="templates" className="mt-6">
            <CardTemplateManagement />
          </TabsContent>
        )}

        {isSuperAdmin && (
          <TabsContent value="settings" className="mt-6">
            <SettingsManagement />
          </TabsContent>
        )}

        {isSuperAdmin && (
          <TabsContent value="admins" className="mt-6">
            <AdminManagement />
          </TabsContent>
        )}

        {isSuperAdmin && (
          <TabsContent value="import-export" className="mt-6">
            <ImportExportManagement />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}